import { render, staticRenderFns } from "./Moral.vue?vue&type=template&id=59302a45&scoped=true"
import script from "./Moral.vue?vue&type=script&lang=js"
export * from "./Moral.vue?vue&type=script&lang=js"
import style0 from "./Moral.vue?vue&type=style&index=0&id=59302a45&prod&scoped=scoped&lang=less"
import style1 from "./Moral.vue?vue&type=style&index=1&id=59302a45&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59302a45",
  null
  
)

export default component.exports